export default __webpack_public_path__ + "static/SanFranciscoText-Medium-fc5288f624d4ab125839d14b38088a05.otf";